module.exports = __webpack_public_path__ + "static/media/collectibleImage.d830a28c.png";